import React, { useEffect, useState } from 'react';

const SlidingToggle = (props) => {
    const {
        label1 = 'Option 1',
        label2 = 'Option 2',
        onChange,
        externalActive = 1,
    } = props
    const [internalActive, setInternalActive] = useState(externalActive);

    useEffect(() => {
        if (externalActive !== internalActive) {
            setInternalActive(externalActive);
        }
    }, [externalActive]);

    const handleClick = (id) => {
        if (id !== internalActive) {
            setInternalActive(id);
            setTimeout(() => {
                onChange?.(id);
            }, 300);
        }
    };

    return (
        <div className="toggle-container">
            <div className={`slider ${internalActive === 1 ? 'button1' : 'button2'}`} />
            <button
                className={internalActive === 1 ? 'active' : ''}
                onClick={() => handleClick(1)}
                style={{whiteSpace:'nowrap'}}
            >
                {label1}
            </button>
            <button
                className={internalActive === 2 ? 'active' : ''}
                onClick={() => handleClick(2)}
                style={{whiteSpace:'nowrap'}}
            >
                {label2}
            </button>
        </div>
    );
};

export default SlidingToggle;


